import { baseApi } from 'segments/api/baseApi';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
  token_type: string;
}

export const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<LoginResponse, LoginRequest>({
      query: (data: LoginRequest) => ({
        url: '/auth/login',
        method: 'POST',
        body: {
          login: data.email,
          password: data.password,
        },
      }),
      invalidatesTags: (result) => result ? ['Auth'] : [],
    }),
  }),
});

export const { useLoginMutation } = authApi;
